import { makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Page } from 'src/components';
import { EventForm } from './components/EventForm';
import { useParams } from 'react-router';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
    minHeight: '92vh'
  }
}));

export const EventSubscriptionDetailsView: FC = () => {
  const params = useParams();
  const classes = useStyles();

  const id = params?.id || 0;

  return (
    <Page className={classes.root} title="Event Subscription Details">
      <Typography color="textPrimary" gutterBottom variant="h3">
        Event Subscription Details
      </Typography>
      <EventForm id={+id || null} />
    </Page>
  );
};
